import { useNavigate } from 'react-router';

import { OneColumn } from 'components/page';
import { ConfigPedidoGrid, ConfigPedidoGridFilter } from 'pages/compra/configuracao-pedido/components';

export function ConfigPedidoList() {
    const navigate = useNavigate();

    return (
        <OneColumn
            title="Configuração de Pedido"
            createButton
            goBackButton
            extraButtons={[
                {
                    title: 'Configuração de Mínimos',
                    onClick: () => navigate('/compra/configuracao-minimo'),
                },
            ]}
        >
            <ConfigPedidoGridFilter />

            <ConfigPedidoGrid />
        </OneColumn>
    );
}
